// extracted by mini-css-extract-plugin
export default {"innerWrapper":"dw-z","tooltipWrapper":"ew-z","icon":"fw-z","tooltip":"gw-z","content":"hw-z"};